import React from 'react';
import { NavLink } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import Logo from '../../assets/images/logo-bullcapital-2x.png';
import './sidebar.css';

const SideBar: React.FC = () => {
  return (
    // Menú lateral

    <Col
      md={3}
      className="sidebar d-flex flex-column align-items-center p-4"
      style={{ height: 'auto' }}
    >
      <img src={Logo} alt="Bell Capital MX" className="img-fluid" style={{ maxWidth: '50%' }} />
      <div>
        <h4>Perfil</h4>
        <hr />
        <ul className="menu-list">
          <li>
            <NavLink to="/profile">Editar perfil</NavLink>
            <NavLink to="/security">Cambiar Contraseña</NavLink>
          </li>
        </ul>
      </div>
      <br />
      <div>
        <h4>Capital</h4>
        <hr />
        <ul className="menu-list">
          <li>
            <NavLink to="/investments">Mis inversiones</NavLink>
            <NavLink to="https://bellcapitalmx.com/services/" target="_blank">
              Calcula una inversión
            </NavLink>
          </li>
        </ul>
      </div>
    </Col>
  );
};

export default SideBar;
